export const iconFontAwesomeMedicalHealthViruses = (
	<i className="fa-solid fa-viruses"></i>
);
